// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c0346359","455":"5de39abb","977":"8513dcb5"}[chunkId] + ".chunk.js";
};